import { i18nMark } from 'lingui-react';

const formattedMessages = {
  make: i18nMark('Make'),
  model: i18nMark('Model'),
  unit: i18nMark('Unit'),
  year: i18nMark('Year'),
};

export default formattedMessages;



// WEBPACK FOOTER //
// ./compositions/CaseOverview/messages.js